import React from 'react';

import styles from './styles.module.scss';

import ImageWithLoader from '@components/_shared/imageWithLoader';
import { ListOnRoveLandingType } from '@utils/types/landings';
import Button from '@components/_shared/button';

const ListOnRoveAdvantage = (props: ListOnRoveLandingType['advantage']) => {
  const { title, description, cta, items } = props;

  const onGetStartedClick = () => {
    const container = document.getElementById('contact');
    window.scrollTo({
      top: (container?.offsetTop || 200) - 200,
      behavior: 'smooth',
    });
  };

  return (
    <div className={styles.roveAdvantage}>
      <div className={styles.roveAdvantage__wrapper}>
        <h4 className={styles.roveAdvantage__title}>{title}</h4>
        <div className={styles.roveAdvantage__description}>{description}</div>

        <div className={styles.roveAdvantage__items}>
          {items.map((item) => (
            <div key={item._key}>
              <ImageWithLoader
                containerStyle={styles.roveAdvantage__image}
                src={item.image}
                alt={title}
                sizes="(max-width: 1024px) 100vw, 33vw"
              />

              <div className={styles.roveAdvantage__itemTitle}>
                {item.title}
              </div>

              <div className={styles.roveAdvantage__itemDescription}>
                {item.description}
              </div>
            </div>
          ))}
        </div>

        <Button
          onClick={onGetStartedClick}
          containerStyle={styles.roveAdvantage__cta}
          variant="greenContained"
        >
          {cta}
        </Button>
      </div>
    </div>
  );
};

export default ListOnRoveAdvantage;
